// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__3RdN5","buttons":"RemoveExpirationActionButtons_buttons__cSbfp"};